import { Offer } from "@prisma/client";
import { trackEvent } from "app/checkout-modal/trackEvent";
import { useClientSideInfo } from "app/checkout-modal/useClientSideInfo";

export const emitSuccessfulPurchaseEvent = async (
  userId: string,
  email: string,
  offers: Offer[],
  clientSideInfo: ReturnType<typeof useClientSideInfo>,
  meta: Record<string, unknown> = {}
) => {
  trackEvent("successful-purchase", {
    type: "successful-purchase",
    payload: {
      ...clientSideInfo,
      client_side_unique_id: clientSideInfo.clientSideId, // this is a stop-gap for pages that are on an older version of CCTM. Anything ripped after 5/30/2024 will not need client_side_unique_id and instead looks for clientSideId
      offers: offers.map((offer) => {
        return {
          id: offer.id,
          installments: offer.numberOfInstallmentsAllowed,
          name: offer.name,
          bookedRevenue: offer.priceInCents,
        };
      }),
      email: email,
      user_id: userId,
      meta,
    },
  });
};
